export default __webpack_public_path__ + "assets/enterprise-one-three-small.f826400b5725f05b9d33fd42b747944a.png";